import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Paginations from "../../../components/paginaton/Paginations";

const ReportCancellOrderSnapp = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [totalPages, setTotalPages] = useState(null);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    saleUnitId: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    startTime: "",
    endDate: "",
    endTime: "",
    sortType: 0,
    cashDeskId: 0,
    cashierUserId: 0,
    paymentType: 0,
    deliveryType: 0,
    merchantName: "",
    invoiceNumber: "",
    merchantPhone: "",
    statusCode: 0,
    rejectSide: 0,
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });

  const [saleUnits, setSaleUnits] = useState([]);
  const [rejectSides, setRejectSides] = useState([]);
  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const getGridData = async () => {
    const resp = await apiMethod.getSnappSalesReport(filterModel);
    if (!methods.showApiErrors(resp)) return false;
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
    setTotalPages(resp.total);
  };

  const getSnappStatuses = async () => {
    const resp = await apiMethod.getSnappStatuses();
    if (!methods.showApiErrors(resp)) return false;
    setStatuses(resp.data);
  };

  const getSnappPaymentType = async () => {
    const resp = await apiMethod.getSnappPaymentTypes();
    if (!methods.showApiErrors(resp)) return false;
    setPaymentTypes(resp.data);
  };

  const getSnappDeliveryType = async () => {
    const resp = await apiMethod.getSnappDeliveryTypes();
    if (!methods.showApiErrors(resp)) return false;
    setDeliveryTypes(resp.data);
  };
  const getSnappRejectSides = async () => {
    const resp = await apiMethod.getSnappRejectSides();
    if (!methods.showApiErrors(resp)) return false;
    setRejectSides(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp1)) setSaleUnits(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getSnappStatuses();
      await getSnappPaymentType();
      await getSnappDeliveryType();
      await getSnappRejectSides();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.saleUnitId = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.startTime = "";
    filterModel.endDate = "";
    filterModel.endTime = "";
    filterModel.sortType = 0;
    filterModel.cashDeskId = 0;
    filterModel.cashierUserId = 0;
    filterModel.paymentType = 0;
    filterModel.deliveryType = 0;
    filterModel.merchantName = "";
    filterModel.invoiceNumber = "";
    filterModel.merchantPhone = "";
    filterModel.statusCode = 0;
    filterModel.rejectSide = 0;
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel });
    setResetKey((prev) => prev + 1);
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const moduleRender = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/reports/home`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                گزارش داده های فروش اسنپ
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>گزارش داده های فروش اسنپ</p>
            </div>
            <div className="salesearchsection">
              <div className="row g-1">
                <div className="col-2">
                  <label htmlFor="txtmerchantname" className="form-label">
                    نام مشتری
                  </label>
                  <input
                    id="txtmerchantname"
                    className="form-control"
                    type="text"
                    value={filterModel.merchantName}
                    onChange={(e) => {
                      filterModel.merchantName = e.target.value;
                      filterModel.part = 1;
                      setFilterModel({ ...filterModel });
                    }}
                  />
                </div>
                <div className="col-2">
                  <label htmlFor="status" className="form-label">
                    وضعیت
                  </label>
                  <select
                    id="status"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.statusCode}
                    onChange={(e) => {
                      filterModel.statusCode = parseInt(e.target.value);
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={0}>همه انواع</option>
                    {statuses.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-2">
                  <label htmlFor="invoicenumber" className="form-label">
                    شماره فاکتور
                  </label>
                  <input
                    id="invoicenumber"
                    className="form-control"
                    type="text"
                    value={filterModel.invoiceNumber}
                    onChange={(e) => {
                      filterModel.invoiceNumber = e.target.value;
                      filterModel.part = 1;
                      setFilterModel({ ...filterModel });
                    }}
                  />
                </div>
                <div className="col-2">
                  <label htmlFor="ddlStatuses" className="form-label">
                    بخش های فروش
                  </label>
                  <select
                    id="ddlStatuses"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.saleUnitId}
                    onChange={(e) => {
                      filterModel.saleUnitId = e.target.value;
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={0}>همه بخش ها</option>
                    {saleUnits.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-2">
                  <label htmlFor="ddlStatuses" className="form-label">
                    بخش های لغو شده
                  </label>
                  <select
                    id="ddlStatuses"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.rejectSide}
                    onChange={(e) => {
                      filterModel.rejectSide = e.target.value;
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={0}>همه بخش ها</option>
                    {rejectSides.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-2">
                  <label htmlFor="ddlStatuses" className="form-label">
                    نوع تحویل
                  </label>
                  <select
                    id="ddlStatuses"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.deliveryType}
                    onChange={(e) => {
                      filterModel.deliveryType = e.target.value;
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={0}>همه بخش ها</option>
                    {deliveryTypes.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-2">
                  <label htmlFor="sort" className="form-label">
                    مرتب سازی
                  </label>
                  <select
                    id="sort"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.sortType}
                    onChange={(e) => {
                      filterModel.sortType = e.target.value;
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={1}>جدیدترین ها</option>
                    <option value={0}>قدیمیترین ها</option>
                  </select>
                </div>
                <div className="col-2">
                  <label htmlFor="ddlPaymentType" className="form-label">
                    نوع پرداخت
                  </label>
                  <select
                    id="ddlPaymentType"
                    className="form-select"
                    aria-label="menu"
                    value={filterModel.paymentType}
                    onChange={(e) => {
                      filterModel.paymentType = parseInt(e.target.value);
                      setFilterModel({ ...filterModel });
                    }}
                  >
                    <option value={0}>همه انواع</option>
                    {paymentTypes.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="startDate" className="form-label">
                    از تاریخ
                  </label>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                    format="YYYY/MM/DD"
                    value={filterModel.startDate}
                    onChange={(value) => {
                      if (value)
                        filterModel.startDate = value.format("YYYY/MM/DD");
                      else filterModel.startDate = "";
                      setFilterModel({ ...filterModel });
                    }}
                    inputClass="form-control"
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="startTime" className="form-label">
                    از ساعت
                  </label>
                  <DatePicker
                    key={`startTime-${resetKey}`}
                    disableDayPicker
                    format="HH:mm"
                    plugins={[
                      <TimePicker hideSeconds value={filterModel.startTime} />,
                    ]}
                    onChange={(value) => {
                      if (value) filterModel.startTime = value.format("HH:mm");
                      else filterModel.startTime = "";
                      setFilterModel({ ...filterModel });
                    }}
                    inputClass="form-control"
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="enddate" className="form-label">
                    تا تاریخ
                  </label>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                    format="YYYY/MM/DD"
                    value={filterModel.endDate}
                    onChange={(value) => {
                      if (value)
                        filterModel.endDate = value.format("YYYY/MM/DD");
                      else filterModel.endDate = "";
                      setFilterModel({ ...filterModel });
                    }}
                    inputClass="form-control"
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="endTime" className="form-label">
                    تا ساعت
                  </label>
                  <DatePicker
                    key={`startTime-${resetKey}`}
                    disableDayPicker
                    format="HH:mm"
                    plugins={[
                      <TimePicker hideSeconds value={filterModel.endTime} />,
                    ]}
                    onChange={(value) => {
                      if (value) filterModel.endTime = value.format("HH:mm");
                      else filterModel.endTime = "";
                      setFilterModel({ ...filterModel });
                    }}
                    inputClass="form-control"
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div className="mt-3 text-center">
                <div className="">
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={searchItem}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info me-1"
                    onClick={clearSearch}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={() => {
                      //   downloadExcelFile();
                    }}
                  >
                    <i className="bi bi-file-earmark-excel"></i>
                  </button> */}
                </div>
              </div>
            </div>
            <table className="table table-striped table-md">
              <thead className="align-middle">
                <tr>
                  <th scope="col vertical-center" width="20px">
                    ردیف
                  </th>
                  <th scope="col vertical-center">نام مشتری</th>
                  <th scope="col vertical-center">شماره تماس</th>
                  <th scope="col vertical-center">تاریخ</th>
                  <th scope="col vertical-center">کد</th>
                  <th scope="col vertical-center">تحویل</th>
                  <th scope="col vertical-center">پرداخت</th>
                  <th scope="col vertical-center">عنوان فروش</th>
                  <th scope="col vertical-center">وضعیت</th>
                  <th scope="col vertical-center">لغو شده</th>
                  <th scope="col vertical-center">مالیات</th>
                  <th scope="col vertical-center">مبلغ</th>
                </tr>
              </thead>
              <tbody className="align-middle">
                {gridData.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      {(filterModel.part - 1) * filterModel.size + index + 1}
                    </td>
                    <td>{item.clientName}</td>
                    <td dir="ltr">{item.clientPhone}</td>
                    <td>
                      {methods.toPersianDate(
                        item.createDate,
                        "jYYYY/jMM/jDD - HH:mm"
                      )}
                    </td>
                    <td>{item.code}</td>
                    <td>{item.deliveryType}</td>
                    <td>{item.paymentType}</td>
                    <td>{item.saleUnitTitle}</td>
                    <td>
                      {{
                        42: "ثبت توسط فروشگاه",
                        51: "رد سفارش توسط فروشگاه",
                        54: "لغو سفارش",
                        56: "سفارش جدید",
                        61: "دریافت سفارش",
                        71: "مبلغ اضافه",
                        713: "باز شده توسط فروشگاه",
                      }[item.statusCode] || "ارسال شده به فروشگاه"}
                    </td>
                    <td>
                      {{
                        0: "لغو نشده",
                        1: "اسنپ",
                        2: "فروشگاه",
                      }[item.rejectSide] || "مشتری"}
                    </td>
                    <td>{methods.addNumSeperator(item.tax)}</td>
                    <td>{methods.addNumSeperator(item.price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filterModel.parts > 1 && (
              <div className="pagination justify-content-center mt-5">
                <Paginations
                  total={totalPages}
                  size={filterModel.size}
                  onPageChange={callPager}
                />
              </div>
            )}
          </>
        }
      </>
    );
  };

  return <div>{moduleRender()}</div>;
};

export default ReportCancellOrderSnapp;
